import { call, select, sleep, take, takeLeading } from "starfx";

import { ensureArray } from "@app/service/helpers";
import {
  CONST_LIST_OF_CONTACTS,
  EMenuCmdTab,
  key_SET_contractors_cff,
} from "@app/state/constants";
import {
  IDBListofContacts,
  IListofContacts,
  TContractor,
} from "@app/types/insider";

import { isErr, isOk } from "../helpers";
import { runThunk, safeLast } from "../helpers/fxhelpers";
import { schema } from "../schema";
import { xApi, xThunk, xWorker } from "../xapis";
import { fetchDatabaseInWorker } from "./ds";
import { sfxNotify } from "./notify";

// import { response } from './testdata'; // <<< mocking anaf response for Softwiz

import type { TPostBackType, TSPVMessageKeys } from "@app/types/insider";
import type { Next, ApiCtx, ThunkCtx } from "starfx";
import type { TANAFResponse, TDBContractor } from "@app/types/insider";
const db = schema;

function* parseableCtx(ctx: ApiCtx) {
  yield* sleep(1);
  return ctx.json;
}

function* identityACtx(ctx: ApiCtx) {
  yield* sleep(1);
  return ctx;
}

export const wgetContractorsMain = xThunk.create(
  "/sfx/select/contractors-cff",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* call(
      fetchDatabaseInWorker.run({
        postBack: true,
        workerEndpoint: "ss_contractors_cff",
        pbkType: "PBK_ALWAYS",
        postBackKey: key_SET_contractors_cff,
      })
    );
    yield* next();
  }
);

export const wgetContractorsTemp = xThunk.create(
  "/sfx/select/contractors-temp",
  { supervisor: takeLeading },
  function* (ctx: ThunkCtx, next: Next) {
    yield* call(
      fetchDatabaseInWorker.run({
        postBack: true,
        workerEndpoint: "ss_contractors_temp",
        pbkType: "PBK_ALWAYS",
      })
    );
    yield* next();
  }
);

export const _______getContractorsMain = xApi.get(
  "/sfx/select/contractors-cff",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/select/ss_contractors_cff",
    });
    yield* next();
    if (isErr(ctx.result)) {
      console.log("ctx.result", ctx.result);
    } else {
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        return;
      }
      const dataMap = data.value.reduce((acc, item) => {
        acc[item.CFF_ID] = item;
        return acc;
      }, {});
      yield* call(schema.update(db.contractors_cff.set(dataMap)));
    }
  }
);

export const _______wgetContractorsMain = xWorker.get(
  "/sfx/wget/contractors-cff",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: `/select/ss_contractors_cff?${new URLSearchParams({
        postBack: "true",
        postBackType: "PBK_ALWAYS" as TPostBackType,
        postBackKey: key_SET_contractors_cff,
      }).toString()}`,
    });
    yield* next();
  }
);

function isNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
export const getContractorsMainOne = xApi.get<number>(
  "/sfx/select/contractors-cff/id",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    if (!isNumber(ctx.payload)) {
      yield* runThunk(sfxNotify, {
        message: "Invalid payload",
        type: "error",
        duration: 2000,
        position: "bottom",
      });
      yield* next();
      return;
    }
    ctx.request = ctx.req({
      url: `/select/ss_contractors_cff?cffid=${ctx.payload}`,
    });
    yield* next();
    if (isErr(ctx.result)) {
      console.log("ctx.result", ctx.result);
    } else {
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        return;
      }
      const dataMap = data.value.reduce((acc, item) => {
        acc[item.CFF_ID] = item;
        return acc;
      }, {});
      yield* call(schema.update(db.contractors_cff.add(dataMap)));
    }
  }
);

export const ____getContractorsTemp = xApi.get(
  "/sfx/select/contractors-temp",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.cache = false;
    ctx.request = ctx.req({
      url: "/select/ss_contractors_temp",
    });
    yield* next();
    if (isErr(ctx.result)) {
      console.log("err in ctx.result", ctx.result);
    } else {
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        return;
      }
      const ds = ensureArray(data.value);
      const dataMap = ds.reduce((acc, item) => {
        // acc[item.CFFTMP_ID] = item;
        acc[item.CIF_NORO] = item;
        return acc;
      }, {});
      yield* call(schema.update(db.contractors_temp.set(dataMap)));
    }
  }
);

export const fxDbValidateCif = xApi.get<TContractor>(
  "/sfx/db/validateCif",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    /// let's test the downstream

    const queryParam = new URLSearchParams({
      CFF_ID: ctx.payload.CffId,
      CIF: ctx.payload.TaxCode,
    });
    ctx.request = ctx.req({
      url: `/select/ss_checkcif?${queryParam.toString()}`,
    });
    yield* next();
  }
);

export const fxSaveContractor = xApi.post<TContractor>(
  "/sfx/saveContractor",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/select/ss_contractors_cff",
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        data: ctx.payload,
      }),
    });
    yield* next();
  }
);

export const fxPutContractorMessageKeys = xApi.put<TSPVMessageKeys>(
  "/sfx/saveContractorMessageKeys",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/select/ss_message_keys",
      headers: {
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify({
        data: ctx.payload,
      }),
    });
    yield* next();
  }
);

// Mapping fields from ANAFResponse to TContractor
export function mapANAFResponseToTContractor(
  anafEntity: TANAFResponse["found"][number]
): TContractor {
  const dateGenerale = anafEntity.date_generale;
  const sediuSocial = anafEntity.adresa_sediu_social;
  const __type = "CONTRACTOR";
  const __messageID = 0;
  const CffId = 0;
  return {
    __type,
    __messageID,
    CffId,
    ClientName: dateGenerale.denumire,
    Address: `${dateGenerale.adresa}`,
    County: "",
    RegistrationNumber: dateGenerale.nrRegCom,
    TaxCode: `${dateGenerale.cui}`,
    Iban: dateGenerale.iban,
    BankName: "",
    Attention: "",
    Phone: dateGenerale.telefon,
    Fax: dateGenerale.fax,
    ClientId: -1,
    AmaIdIns: -1,
    City: sediuSocial.sdenumire_Localitate,
    CountryCode: "RO",
    CountyCode: `RO-${sediuSocial.scod_JudetAuto}`,
    Email: "",
    PostalCode: dateGenerale.codPostal,
    AdditionalAddress: "",
    BuyerReference: "",
    UsingRoEfactura: 1,
    __num: undefined,
  };
}
const mapANAFResponseToTDBContractor = (
  anafEntity: TANAFResponse["found"][number]
): TDBContractor => {
  const dateGenerale = anafEntity.date_generale;
  const sediuSocial = anafEntity.adresa_sediu_social;
  const scopTVA = anafEntity.inregistrare_scop_Tva;
  return {
    ORAS: sediuSocial.sdenumire_Localitate,
    COD_POSTAL: dateGenerale.codPostal,
    COD_JUDET: sediuSocial.scod_JudetAuto
      ? `RO-${sediuSocial.scod_JudetAuto}`
      : null,
    ADRESA_SUPLIMENTARA: sediuSocial.sdetalii_Adresa,
    COD_TARA: "RO",
    TELEFON: dateGenerale.telefon,
    BUYER_REFERENCE: "",
    CFF_ID: 0,
    C_ID: 0,
    DENUMIRE_F: dateGenerale.denumire,
    ADRS_F: dateGenerale.adresa,
    JUDETUL: sediuSocial.sdenumire_Judet,
    NR_INREG: dateGenerale.nrRegCom,
    CIF: `${dateGenerale.cui}`,
    IBAN: dateGenerale.iban,
    BANCA: "",
    INATENTIA: "",
    FAX: dateGenerale.fax,
    AMA_ID_INS: 0,
    DATA_INS: "",
    CFF_EMAIL: "",
    CFF_COD_POSTAL: "",
    CIF_NORO: (`${dateGenerale.cui}` || "").replaceAll("RO", ""),
    USING_RO_EFACTURA: 1,
    __alertaNeplatitorTVA: scopTVA.scpTVA,
  };
};

export const anafQuery = xApi.get<{ cui: string }>(
  "/sfx/anafQuery",
  { supervisor: takeLeading },
  [
    function* (ctx: ApiCtx, next: Next) {
      ctx.cache = true;
      ctx.request = ctx.req({
        url: `/anaf/?cui=${ctx.payload.cui}`,
      });
      yield* next();
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        // if we are not in ANAF tab, we don't want to show the error message
        const currentState = yield* select(schema.uiInvoiceOverall.select);
        const crtTab = currentState.selectedCtorMirrorTab;
        const hashParams = new URLSearchParams(
          window.location.hash.split("?")[1]
        ); // Split by '#' and take the second part to get query string
        const kw = hashParams.get("keyword");

        if (crtTab === "ANAF" || kw === EMenuCmdTab.CMD_BGIM_EMITENT) {
          yield* runThunk(sfxNotify, {
            message: data.error.message,
            type: "error",
            duration: 2000,
            position: "bottom",
          });
        }
        return;
      } else {
        if (isOk(data)) {
          const dataset = data.value as TANAFResponse;
          for (const item of dataset.found) {
            const mapped = mapANAFResponseToTDBContractor(item);
            yield* schema.update(
              db.contractors_anaf.add({ [mapped.CIF_NORO]: mapped })
            );
          }
          dataset.notFound.length &&
            sfxNotify({
              message: `CIF-uri neregasite in raspunsul ANAF: ${dataset.notFound.join(
                ", "
              )}`,
              type: "error",
            });
        }
      }
    },
    // function* (ctx, next) {
    //   ctx.response = new Response(JSON.stringify(response));
    //   yield* next();
    // },
  ]
);

export const anafPost = xApi.post<{ cui: string }[]>(
  "/sfx/anafQuery",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.cache = true;
    ctx.key = `anaf-${ctx.payload.cui}`;
    ctx.request = ctx.req({
      method: "POST",
      url: `/anaf`,
      body: JSON.stringify({ cui: ctx.payload.cui }),
    });
    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      yield* runThunk(sfxNotify, {
        message: data.error.message,
        type: "error",
        duration: 2000,
        position: "bottom",
      });
      return;
    } else {
      if (isOk(data)) {
        const dataset = data.value as TANAFResponse;
        for (const item of dataset.found) {
          const mapped = mapANAFResponseToTDBContractor(item);
          yield* schema.update(
            db.contractors_anaf.add({ [mapped.CIF_NORO]: mapped })
          );
        }
        dataset.notFound.length &&
          sfxNotify({
            message: `CIF-uri neregasite in raspunsul ANAF: ${dataset.notFound.join(
              ", "
            )}`,
            type: "error",
          });
      }
    }
  }
);

export const getListOfContacts = xApi.get(
  "/sfx/select/contacts",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      //ss_listOf_contacts//
      url: `/select/ss_${CONST_LIST_OF_CONTACTS}`,
    });
    yield* next();
    if (isErr(ctx.result)) {
      console.log("err in ctx.result", ctx.result);
    } else {
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        return;
      }
      const dataMap = data.value.reduce(
        (acc, item: IDBListofContacts): IListofContacts => {
          if (!item.C_ID) return acc;
          acc[item.C_ID] = {
            C_ID: item.C_ID,
            DENUMIRE: item.DENUMIRE,
            LEGAL_FORM: item.LEGAL_FORM,
            ADRESE: `${item.ADRESE_1 || ""}${item.ADRESE_2 || ""}${
              item.ADRESE_3 || ""
            }`,
            TELEFON: item.TELEFON,
            FAX: item.FAX,
            EMAIL: item.EMAIL,
            WEB_SITE: item.WEB_SITE,
            OBSERVATII: item.OBSERVATII,
            CERINTE_SPECIALE: item.CERINTE_SPECIALE,
            DT_INSERTED: item.DT_INSERTED,
            AVO_INSERTED: item.AVO_INSERTED,
            DT_UPDATED: item.DT_UPDATED,
            AVO_UPDATED: item.AVO_UPDATED,
            NR_INREG: item.NR_INREG,
            CIF: item.CIF,
            IBAN: item.IBAN,
            BANCA: item.BANCA,
          };
          return acc;
        }
      );
      yield* call(schema.update(db.contactlist.set(dataMap)));
    }
  }
);

export const getIso3166_2 = xApi.get<{ countryCode: string }>(
  "/sfx/select/iso3166-2",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.cache = true;
    ctx.request = ctx.req({
      url: `/select/ss_iso3166_2?country=${ctx.payload.countryCode}`,
    });
    yield* next();
    if (isErr(ctx.result)) {
      console.log("err in ctx.result", ctx.result);
    } else {
      const data = yield* safeLast(parseableCtx(ctx));
      if (isErr(data)) {
        console.log("error in data", data);
        return;
      }
      const dataMap = data.value.reduce((acc, item) => {
        acc[item.ISOID] = item;
        return acc;
      }, {});
      yield* call(schema.update(db.iso3166_2.set(dataMap)));
    }
  }
);

export const wgetContacts = xWorker.get(
  "/sfx/wget/contacts",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: "/select/ss_listOf_contacts",
    });
    yield* next();
    // ctx.response = new Response();
    // ctx.json = {
    //   ok: true,
    //   value: [],
    // };
  }
);

export const wgetIso3166_2 = xWorker.get<{ countryCode: string }>(
  "/sfx/wget/iso3166-2",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    ctx.request = ctx.req({
      url: `/select/ss_iso3166_2?country=${ctx.payload.countryCode}`,
    });
    yield* next();
    // ctx.response = new Response();
    // ctx.json = {
    //   ok: true,
    //   value: [],
    // };
  }
);
